exports.f=Object.getOwnPropertySymbols;